import CloseIcon from '@mui/icons-material/Close'
import InfoIcon from '@mui/icons-material/Info'
import { Alert, IconButton } from '@mui/material'
import React from 'react'

interface CalendarPageHintProps {
  visible: boolean
  onDismiss: () => void
}

/**
 * CalendarPageHint - Instructional hint for calendar page
 *
 * Displays a dismissible alert with instructions on how to book a desk.
 * Follows Material-UI theme patterns and ensures responsive design for mobile.
 *
 * **Validates: Requirements 11.1, 11.2, 11.3**
 */
const CalendarPageHint: React.FC<CalendarPageHintProps> = ({
  visible,
  onDismiss
}) => {
  if (!visible) {
    return null
  }

  return (
    <Alert
      severity='info'
      icon={<InfoIcon />}
      action={
        <IconButton
          aria-label='close'
          color='inherit'
          size='small'
          onClick={onDismiss}
        >
          <CloseIcon fontSize='inherit' />
        </IconButton>
      }
      sx={{
        mb: 2,
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }
      }}
    >
      Click on a date to book a desk
    </Alert>
  )
}

export default CalendarPageHint
